import { useContext } from 'react';
import { BookingTokensContext } from './BookingThemeContext';
import { resolveBookingTokens, type BookingThemeTokens } from './personalities';

export function useBookingTokens(): BookingThemeTokens {
  return useContext(BookingTokensContext) ?? resolveBookingTokens('classic');
}
